import { useState } from "react";

export default function AdminFloatingAssistant() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setOpen(!open)}
        className="admin-assistant-btn fixed bottom-24 lg:bottom-6 left-4 lg:left-6 z-40"
        title="دستیار هوش مصنوعی"
      >
        {open ? (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
            <path d="M12 2a4 4 0 014 4c0 2-2 4-4 6-2-2-4-4-4-6a4 4 0 014-4z" />
            <path d="M12 14v4" />
            <path d="M8 22h8" />
            <path d="M12 18v4" />
          </svg>
        )}
      </button>

      {/* Chat Overlay */}
      {open && (
        <div className="fixed bottom-40 lg:bottom-24 left-4 lg:left-6 z-40 w-[calc(100vw-2rem)] max-w-[24rem] sm:w-80 md:w-96">
          <div className="admin-glass rounded-3xl overflow-hidden shadow-2xl">
            {/* Header */}
            <div className="px-5 py-4 flex items-center justify-between" style={{ background: "var(--admin-primary)" }}>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-xl flex items-center justify-center" style={{ background: "rgba(255,255,255,0.2)" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
                    <path d="M12 2a4 4 0 014 4c0 2-2 4-4 6-2-2-4-4-4-6a4 4 0 014-4z" />
                    <path d="M12 14v4" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-white">دستیار هوش مصنوعی</h3>
                  <p className="text-[11px]" style={{ color: "rgba(255,255,255,0.7)" }}>آنلاین</p>
                </div>
              </div>
              <button
                onClick={() => setOpen(false)}
                className="transition-colors"
                style={{ color: "rgba(255,255,255,0.7)" }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            {/* Messages */}
            <div className="p-4 h-64 overflow-y-auto space-y-3 bg-white">
              <div className="flex items-start gap-2">
                <div className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 mt-0.5" style={{ background: "rgba(7,135,131,0.1)" }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--admin-primary)" strokeWidth="2" strokeLinecap="round">
                    <path d="M12 2a4 4 0 014 4c0 2-2 4-4 6-2-2-4-4-4-6a4 4 0 014-4z" />
                    <path d="M12 14v4" />
                  </svg>
                </div>
                <div className="rounded-2xl rounded-tr-sm px-4 py-2.5 text-sm max-w-[85%]" style={{ background: "var(--admin-bg)", color: "var(--admin-text-primary)" }}>
                  سلام! من دستیار هوش مصنوعی هستم. چطور می‌توانم به شما کمک کنم؟
                </div>
              </div>

              <div className="flex items-start gap-2 justify-end">
                <div className="text-white rounded-2xl rounded-tl-sm px-4 py-2.5 text-sm max-w-[85%]" style={{ background: "var(--admin-primary)" }}>
                  سلام! راهنمایی برای مدیریت کاربران نیاز دارم.
                </div>
                <div className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 mt-0.5 text-white text-xs font-bold" style={{ background: "var(--admin-primary)" }}>
                  M
                </div>
              </div>

              <div className="flex items-start gap-2">
                <div className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 mt-0.5" style={{ background: "rgba(7,135,131,0.1)" }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--admin-primary)" strokeWidth="2" strokeLinecap="round">
                    <path d="M12 2a4 4 0 014 4c0 2-2 4-4 6-2-2-4-4-4-6a4 4 0 014-4z" />
                    <path d="M12 14v4" />
                  </svg>
                </div>
                <div className="rounded-2xl rounded-tr-sm px-4 py-2.5 text-sm max-w-[85%]" style={{ background: "var(--admin-bg)", color: "var(--admin-text-primary)" }}>
                  می‌توانید از بخش "کاربران" در منوی سمت راست، لیست تمام کاربران را مشاهده کنید. برای جستجوی کاربر خاص از نوار جستجو استفاده کنید.
                </div>
              </div>
            </div>

            {/* Input */}
            <div className="p-3 bg-white" style={{ borderTop: "1px solid var(--admin-border)" }}>
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="پیام خود را بنویسید..."
                  className="flex-1 px-4 py-2.5 rounded-xl text-sm transition-all"
                  style={{ border: "1px solid var(--admin-border)", color: "var(--admin-text-primary)" }}
                  onFocus={(e) => { e.currentTarget.style.borderColor = "var(--admin-primary)"; e.currentTarget.style.boxShadow = "0 0 0 3px rgba(7,135,131,0.1)"; }}
                  onBlur={(e) => { e.currentTarget.style.borderColor = "var(--admin-border)"; e.currentTarget.style.boxShadow = "none"; }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && message.trim()) {
                      setMessage("");
                    }
                  }}
                />
                <button
                  onClick={() => setMessage("")}
                  disabled={!message.trim()}
                  className="w-10 h-10 rounded-xl text-white flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  style={{ background: "var(--admin-primary)" }}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <line x1="22" y1="2" x2="11" y2="13" />
                    <polygon points="22 2 15 22 11 13 2 9 22 2" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}